import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { COLORS } from "assets/styles/colors";
import { Icons } from "assets/svgs";
import { PrimaryButton } from "common";
import { clientRoutes } from "router/routes";
import { clientSelectors } from "store/client-slice/selectors";
import { ownerPortalPropertyActions } from "store/owner-portal-property-slice/slice";
import { toggleClassOnRoot } from "utils/helpers";

import * as S from "./styled";

export const SuccessModal = ({ submitAdditionalEvidence }) => {
  const { account } = useSelector(clientSelectors);

  const [firstAnimation, setFirstAnimation] = useState(true);
  const [secondAnimation, setSecondAnimation] = useState(false);

  const { id } = useParams();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleAnimate = () => setSecondAnimation(true);

  const handleAnimationEnd = () => {
    setFirstAnimation(false);
    setSecondAnimation(false);
  };
  window.dataLayer.push({
    event: "user_email",
    email: account?.email,
  });

  const handleExit = () => {
    toggleClassOnRoot();
    dispatch(ownerPortalPropertyActions.setIsOpenEvidenceSuccessModal(false));
    dispatch(ownerPortalPropertyActions.resetAllData());
    navigate(`${clientRoutes.prefix}${clientRoutes.properties}?id=${id}&should-scroll=true`);
  };

  return (
    <S.Container onClick={handleAnimate}>
      <S.Content
        className={`${secondAnimation ? "second-animation" : ""} ${firstAnimation ? "first-animation" : ""}`}
        onAnimationEnd={handleAnimationEnd}
        onClick={(e) => e.stopPropagation()}
      >
        <S.BoxCenter>
          <S.IconWrapper>
            <Icons.CheckIcon size={45} />
          </S.IconWrapper>
        </S.BoxCenter>
        <S.BoxCenter>
          <S.Description>The evidence has been added to your file to be used for this year's protest.</S.Description>
        </S.BoxCenter>
        <S.BoxCenter>
          <S.ButtonsWrapper>
            <PrimaryButton
              eventHandler={submitAdditionalEvidence}
              label="submit aditional evidence"
              styles={{
                backgroundColor: COLORS.deepDark,
                height: 50,
              }}
            />
            <PrimaryButton
              eventHandler={handleExit}
              label="exit"
              styles={{
                backgroundColor: COLORS.white,
                color: COLORS.dark,
                border: `1px solid ${COLORS.dark}`,
                height: 50,
              }}
            />
          </S.ButtonsWrapper>
        </S.BoxCenter>
      </S.Content>
    </S.Container>
  );
};
